import styles from "./styles.module.scss";

import LinearProgress from "@mui/material/LinearProgress";
import Paper from "@mui/material/Paper";
import { Box } from "@mui/material";

interface DefaultProgressProps {
  title?: string;
  value1?: string;
  value2?: string;
  progressValue?: number;
}

const ProgressBar: React.FC<DefaultProgressProps> = ({
  title = "",
  value1 = "",
  value2 = "",
  progressValue = 0,
}) => {
  const progressBarColor = progressValue > 100 ? "#E73030" : "#0989EF";
  const limitedProgressValue = Math.min(progressValue, 100);
  return (
    <>
      <div className={styles.progressRow}>
        <div className={styles.progressTitle}>{title}</div>
        <div className={styles.progressValue}>
          <span className={styles.firstPart}>{value1}</span>
          <span className={styles.secondPart}>
            {value2 ? ` ${value2}` : ""}
          </span>
        </div>
      </div>
      <div>
        <LinearProgress
          variant="determinate"
          value={limitedProgressValue}
          className={styles.progressBar}
          sx={{
            "& .MuiLinearProgress-bar": {
              backgroundColor: progressBarColor,
            },
          }}
        />
      </div>
    </>
  );
};

interface DefaultPaperProps {
  scheduled?: string;
  progressBars?: React.ReactNode[];
  filterState: any;
}

const DefaultPaper: React.FC<DefaultPaperProps> = ({
  scheduled = "",
  progressBars = [],
  filterState,
}) => {
  return (
    <Paper className={styles.scheduledPaper}>
      <div className={styles.scheduledRow}>
        <div className={styles.scheduledTitle}>
          {filterState.timeMode === 1 ? "Horas Agendadas" : "Dias Agendados"}{" "}
        </div>
        <div className={styles.scheduledValue}>{scheduled}</div>
      </div>
      <div>
        {progressBars.map((progressBar, index) => (
          <div key={index}>{progressBar}</div>
        ))}
      </div>
    </Paper>
  );
};

interface DefaultDataProps {
  scheduledData?: string;
  billedData?: string;
  billedPercentData?: number;
  notBilledData?: string;
  notBilledPercentData?: number;
  filterState: any;
}

export const DefaultPaperReport: React.FC<DefaultDataProps> = ({
  scheduledData = "0",
  billedData = "0",
  billedPercentData = 0,
  notBilledData = "0",
  notBilledPercentData = 0,
  filterState,
}) => {
  return (
    <Box className={styles.projectGridContainer}>
      <DefaultPaper
        scheduled={scheduledData}
        progressBars={[
          <ProgressBar
            key="billed"
            title="Faturável"
            value1={billedData}
            value2={`(${billedPercentData.toLocaleString("pt-BR")}%)`}
            progressValue={billedPercentData}
          />,
          <ProgressBar
            key="notBilled"
            title="Não Faturável"
            value1={notBilledData}
            value2={`(${notBilledPercentData.toLocaleString("pt-BR")}%)`}
            progressValue={notBilledPercentData}
          />,
        ]}
        filterState={filterState}
      />
    </Box>
  );
};
